// // import React from 'react';
// // import { Box, Card, CardContent, Grid, Typography, Avatar } from '@mui/material';
// // import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// // import PeopleIcon from '@mui/icons-material/People';
// // import GroupAddIcon from '@mui/icons-material/GroupAdd';
// // import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

// // const stats = [
// //     {
// //         icon: <AttachMoneyIcon />,
// //         iconColor: '#212121',
// //         title: "Total Employee",
// //         value: '53',
// //         // subtext: '+55% than last week',
// //         subtextColor: 'green',
// //     },
// //     {
// //         icon: <PeopleIcon />,
// //         iconColor: '#e91e63',
// //         title: "Employee Evaluation Completed",
// //         value: '2,300',
// //         subtext: '+3% than last month',
// //         subtextColor: 'green',
// //     },
// //     {
// //         icon: <GroupAddIcon />,
// //         iconColor: '#4caf50',
// //         title: 'Manager Evaluation Completed',
// //         value: '3,462',
// //         subtext: '-2% than yesterday',
// //         subtextColor: 'red',
// //     },
// //     {
// //         icon: <ShoppingCartIcon />,
// //         iconColor: '#2196f3',
// //         title: 'PMS Closed',
// //         value: '$103,430',
// //         subtext: '+5% than yesterday',
// //         subtextColor: 'green',
// //     },
// // ];

// // const StatCard = ({ icon, iconColor, title, value, subtext, subtextColor }) => (

// //     <Box sx={{ position: "relative" }}>
// //         <Card sx={{ display: 'flex', alignItems: 'center', p: 2, boxShadow: 3 }}>

// //             <Box sx={{
// //                 bgcolor: iconColor, mr: 2,
// //                 // ,position:"absolute",top:-10,
// //                 zIndex: 1,
// //                 position: 'absolute',
// //                 top: -24,
// //                 left: 16,
// //                 boxShadow: 2,
// //                 borderRadius: "15px"


// //             }}>
// //                 <Box
// //                     sx={{
// //                         display: "flex",
// //                         justifyContent: "center",
// //                         alignItem: "center",
// //                         px: 2,
// //                         py: 2,
// //                     }}
// //                 >
// //                     {icon}
// //                 </Box>
// //             </Box>
// //             <Box sx={{ display: 'flex', alignItems: "end", p: 2,justifyContent:'end' }}>
// //                 <Box>
// //                     <Typography variant="body2" color="textSecondary">
// //                         {title}
// //                     </Typography>
// //                     <Typography variant="h6" fontWeight="bold">
// //                         {value}
// //                     </Typography>
// //                     <Typography variant="caption" color={subtextColor}>
// //                         {subtext}
// //                     </Typography>
// //                 </Box>
// //             </Box>
// //         </Card>
// //     </Box>
// // );

// // function DashboardCard() {
// //     return (
// //         <Grid container spacing={2}>
// //             {stats.map((stat, index) => (
// //                 <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={index}>
// //                     <StatCard {...stat} />
// //                 </Grid>
// //             ))}
// //         </Grid>
// //     );
// // }
// // export default DashboardCard;

// import React from 'react';
// import { Box, Card, Grid, Typography } from '@mui/material';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import PeopleIcon from '@mui/icons-material/People';
// import GroupAddIcon from '@mui/icons-material/GroupAdd';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

// const stats = [
//     {
//         icon: <AttachMoneyIcon sx={{ color: '#fff' }} />,
//         iconColor: '#212121',
//         title: "Total Employee",
//         value: '53',
//         subtextColor: 'green',
//     },
//     {
//         icon: <PeopleIcon sx={{ color: '#fff' }} />,
//         iconColor: '#e91e63',
//         title: "Employee Evaluation Completed",
//         value: '2,300',
//         subtextColor: 'green',
//     },
//     {
//         icon: <GroupAddIcon sx={{ color: '#fff' }} />,
//         iconColor: '#4caf50',
//         title: 'Manager Evaluation Completed',
//         value: '3,462',
//         subtextColor: 'red',
//     },
//     {
//         icon: <ShoppingCartIcon sx={{ color: '#fff' }} />,
//         iconColor: '#2196f3',
//         title: 'PMS Closed',
//         value: '$103,430',
//         subtextColor: 'green',
//     },
// ];

// const StatCard = ({ icon, iconColor, title, value, subtext, subtextColor }) => (
//     <Box sx={{
//         position: "relative",
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-end',
//         background: "white",
//         boxShadow: 3,
//         pt: 4,
//         pb: 2,
//         px: 2,

//     }}>

//         <Card
//             sx={{
//                 // height: '100%',
//                 // display: 'flex',
//                 // flexDirection: 'column',
//                 // justifyContent: 'flex-end',
//                 // boxShadow: 3,
//                 // pt: 4,
//                 // pb: 2,
//                 // px: 2,
//             }}
//         >
//             <Box
//                 sx={{
//                     bgcolor: iconColor,
//                     position: 'absolute',
//                     top: -24,
//                     left: 16,
//                     borderRadius: '15px',
//                     boxShadow: 2,
//                     p: 1.5,
//                 }}
//             >
//                 {icon}
//             </Box>

//             <Box sx={{
//                 mt: 'auto',

//                 // bgcolor: iconColor,
//                 position: 'absolute',
//                 top: 0,
//                 right: 0,
//                 borderRadius: '15px',
//                 boxShadow: 2,
//                 p: 1.5,

//             }}>
//                 <Typography variant="body2" color="textSecondary">
//                     {title}
//                 </Typography>
//                 <Typography variant="h6" fontWeight="bold">
//                     {value}
//                 </Typography>
//                 {subtext && (
//                     <Typography variant="caption" color={subtextColor}>
//                         {subtext}
//                     </Typography>
//                 )}
//             </Box>
//         </Card >
//     </Box >
// );

// function DashboardCard() {
//     return (
//         <Grid container spacing={2}>
//             {stats.map((stat, index) => (
//                 <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={index}>
//                     <Box sx={{ height: '100%' }}>
//                         <StatCard {...stat} />
//                     </Box>
//                 </Grid>
//             ))}
//         </Grid>
//     );
// }

// export default DashboardCard;



import React from 'react';
import { Box, Divider, Grid, Paper, Typography } from '@mui/material';

// const stats = [
//     {
//         icon: <AttachMoneyIcon sx={{ color: '#fff' }} />,
//         iconColor: '#212121',
//         title: 'Total Employee',
//         value: '53',
//     },
//     {
//         icon: <PeopleIcon sx={{ color: '#fff' }} />,
//         iconColor: '#e91e63',
//         title: 'Employee Evaluation Completed',
//         value: '2,300',
//     },
//     {
//         icon: <GroupAddIcon sx={{ color: '#fff' }} />,
//         iconColor: '#4caf50',
//         title: 'Manager Evaluation Completed',
//         value: '3,462',
//     },
//     {
//         icon: <ShoppingCartIcon sx={{ color: '#fff' }} />,
//         iconColor: '#2196f3',
//         title: 'PMS Closed',
//         value: '$103,430',
//     },
// ];

const StatCard = ({ icon, iconColor, title, value, pending, total, completed, active, inActive }) => (
    <Paper
        sx={{
            padding: 2,
            backgroundColor: 'white',
            borderRadius: 2,
            boxShadow: 3,
            height: '100%',
            cursor: 'pointer',
        }}
    >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
            <Typography variant="subtitle2" sx={{ fontSize: '14px', color: 'var(--main-color)' }}>
                {title}
            </Typography>
            <Box
                sx={{
                    backgroundColor: iconColor,
                    borderRadius: '5px',
                    // height: '40px',
                    // width: '40px',
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {icon}
            </Box>
        </Box>
        {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box>
                <Typography variant="subtitle2" sx={{ color: 'black', marginTop: 2 }}>
                    Total
                </Typography>
                <Typography variant="h6" sx={{ color: 'black', fontWeight: '800', marginTop: 2 }}>
                    {value}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem sx={{ my: 2 }} />


            <Box>
                <Typography variant="subtitle2" sx={{ color: 'black', marginTop: 2 }}>
                    Pending
                </Typography>
                <Typography variant="h6" sx={{ color: 'black', fontWeight: '800', marginTop: 2 }}>
                    {value}
                </Typography>
            </Box>

        </Box> */}

        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
           
            <Box>
                <Typography variant="subtitle2" sx={{ color: 'black', marginTop: 2 }}>
                    Total
                </Typography>
                <Typography variant="h6" sx={{ color: 'black', fontWeight: '800', marginTop: 1 }}>
                    {total ?? 0}
                </Typography>
            </Box>

            {pending !== undefined && (
                <>
                    <Divider orientation="vertical" flexItem sx={{ my: 2 }} />
                    <Box>
                        <Typography variant="subtitle2" sx={{ color: 'black', marginTop: 2 }}>
                            Pending
                        </Typography>
                        <Typography variant="h6" sx={{ color: 'black', fontWeight: '800', marginTop: 1 }}>
                            {pending}
                        </Typography>
                    </Box>
                </>
            )}
            {completed !== undefined && (
                <>
                    <Divider orientation="vertical" flexItem sx={{ my: 2 }} />
                    <Box>
                        <Typography variant="subtitle2" sx={{ color: 'black', marginTop: 2 }}>
                            Completed
                        </Typography>
                        <Typography variant="h6" sx={{ color: 'black', fontWeight: '800', marginTop: 1 }}>
                            {completed}
                        </Typography>
                    </Box>
                </>
            )}
            {active !== undefined && (
                <>
                    <Divider orientation="vertical" flexItem sx={{ my: 2 }} />
                    <Box>
                        <Typography variant="subtitle2" sx={{ color: 'black', marginTop: 2 }}>
                            Active
                        </Typography>
                        <Typography variant="h6" sx={{ color: 'black', fontWeight: '800', marginTop: 1 }}>
                            {active}
                        </Typography>
                    </Box>
                </>
            )}
            {inActive !== undefined && (
                <>
                    <Divider orientation="vertical" flexItem sx={{ my: 2 }} />
                    <Box>
                        <Typography variant="subtitle2" sx={{ color: 'black', marginTop: 2 }}>
                            Inacitve
                        </Typography>
                        <Typography variant="h6" sx={{ color: 'black', fontWeight: '800', marginTop: 1 }}>
                            {inActive}
                        </Typography>
                    </Box>
                </>
            )}
        </Box>
        {/* <Typography variant="h6" sx={{ color: 'black', fontWeight: '800', marginTop: 2 }}>
            {value}
        </Typography> */}
    </Paper>
);

function DashboardCard({ stats }) {



    return (
        <Grid container spacing={2}>
            {stats?.map((stat, index) => (
                <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                    <StatCard {...stat} />
                </Grid>
            ))}
        </Grid>
    );
}

export default DashboardCard;
